import moment from "moment/moment";
import {FormControlLabel, Switch} from "@mui/material";
import {useEffect, useState} from "react";
import FunctionsData from "../Functions/FunctionsData";

export default function VetCampaignsInAreaData ({loading,title,data, setLoading, vet_id, optOut = true}) {

    console.log("optout value in vetcampaignsinareadata ", optOut);
    const boxStyle = {
        background:'rgba(0,0,0,0.05)',
        padding:10,
        marginBottom:10
    }

    if(loading === true) return null;
    return (
        <div className="dashboard-box">
            <div className="header">
                {title} ({data.length})
            </div>
            <div className="dashboard-content no-footer">
                {
                    (data.length > 0) ?
                        <div>
                            {
                                data.map((row,idx) => {
                                    return (
                                        <ShowRow key={row.campaign_id} {...{row,idx, boxStyle}} setLoading={setLoading} vet_id={vet_id} optOut={optOut} />
                                    )
                                })
                            }
                        </div>
                        : <div>No vouchers found for {title}.</div>
                }
            </div>
        </div>
    )

}

function ShowRow({row,idx, boxStyle,vet_id,setLoading, optOut}) {
    console.log("optout value in showRow ", optOut);
    const [sel,setSelected] = useState(0);

    useEffect(() => {
        if(optOut){
        const ec = String(row.excluded_campaigns).replace(/null/g,'').split(',');
        console.log(ec, !ec.map(i => String(i)).includes(String(row.campaign_id)))
        setSelected(!ec.map(i => String(i)).includes(String(row.campaign_id)) ? 1 : 0);
        } else {
            setSelected(0);
            //updateVetCampaign(0);
        }
    }, [row.campaign_id, row.excluded_campaigns, optOut])

    function updateVetCampaign(checked) {

        let excluded_campaigns = String(row.excluded_campaigns).replace(/null/g,'').split(',');

        if(checked === true) {
            excluded_campaigns = excluded_campaigns.filter((item) => String(item) !== String(row.campaign_id));
        }else{
            excluded_campaigns.push(String(row.campaign_id));
        }

        const toUpdate = [...new Set(excluded_campaigns)]
        console.log('Test', excluded_campaigns.join(','))

        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/vet/')+vet_id,
            {excluded_campaigns:toUpdate.join(',')}
        )
            .then((data) => {
                setLoading(true);
            })
    }

    return (
        <div key={idx} style={boxStyle}>
            <div style={{display:'flex', flexDirection:'row'}}>
                <div style={{flexGrow:1}}><strong>{row.name}</strong></div>
                <div style={{flexGrow:0}}>
                    <FormControlLabel control={<Switch checked={sel} onChange={(e) => {                        
                        setSelected(e.target.checked);
                        updateVetCampaign(e.target.checked);
                    }} />} label="" />
                </div>
            </div>
            {sel === 0 && <div style={{flexGrow:0, color:'red'}}>You are not available for this campaign.</div>}
            {sel === 1 && <div style={{flexGrow:0, color:'green'}}>You are part of this campaign.</div>}
            <small>Start: {moment(row.start_date).format('DD/MM/YYYY')} End: {moment(row.end_date).format('DD/MM/YYYY')}</small>
            <small>
                {row.description && <div>{row.description}</div> }
                {row.postcodes && <div>{row.postcodes.replace(/,/g,', ')}</div> }
            </small>
        </div>
    )
}
